<template>
  <div class="mc-wrapper">
    <div class="mc-container">
      <div v-if="certificateLoading" class="mc-loader"><span class="mc-loader__circle"></span></div>
      <div v-if="certificateError" class="mc-error">{{ certificateError }}</div>
      <div v-if="certificateLoaded" class="mc-certificates">
        <div class="mc-certificates__text">
          <p>
            Подарочный сертификат Mcbuy — идеальный подарок, который приятно и дарить и получать. С ним вы никогда не ошибетесь с цветом, фасоном или размером и сэкономите свое время на поиск подходящего подарка. Электронный подарочный сертификат Mcbuy принимается к оплате в интернет-магазине mcbuy.ru. Номинал сертификата можно выбрать из представленных ниже, а ваши близкие могут использовать эту сумму полностью или частично.
          </p>
          <p>
            Новый формат электронного подарочного сертификата позволит вам сделать красивый подарок, отправив его в виде письма на почту, где бы вы не находились. После внесения оплаты на вашу почту поступит информационное сообщение и последующее письмо с номером сертификата и штрих-кодом. После этого перешлите письмо получателю, сертификат готов к использованию. Подарочный сертификат действует на все товары в интернет-магазине. <a href="https://www.mcbuy.ru/upload/%D0%A0%D0%B5%D0%B3%D0%BB%D0%B0%D0%BC%D0%B5%D0%BD%D1%82%20%D0%9F%D0%BE%D0%B4%D0%B0%D1%80%D0%BE%D1%87%D0%BD%D1%8B%D0%B5%20%D1%81%D0%B5%D1%80%D1%82%D0%B8%D1%84%D0%B8%D0%BA%D0%B0%D1%82%D1%8B%20(1).pdf">Регламент "Подарочные сертификаты".</a>
          </p>
        </div>
        <div class="mc-certificates__form mc-form">
          <div class="mc-certificates__denomination">
            <picture class="mc-certificates__form-picture">
              <img class="mc-certificates__form-image" src="/assets/content/cards/img-big-1.png" width="330" height="207" alt="">
            </picture>
            <fieldset class="mc-form__fieldset">
              <div class="mc-form__fieldset-title">
                Выберите номинал сертификата
              </div>
              <ul class="mc-form__button-list">
                <li v-for="item in certificate" class="mc-form__button-item">
                  <input class="mc-form__checkbox-button js-checkbox-button" type="radio" v-model="denomination" :id="'denomination-'+item.id" :value="item.id">
                  <label class="mc-form__checkbox-label simulated-hover" :for="'denomination-'+item.id">
                    {{ item.price }} ₽
                  </label>
                </li>
              </ul>
            </fieldset>
          </div>
          <router-link :to="'/certificates/buy/?id='+denomination" class="mc-form__button-submit mc-button mc-button--color js-button-submit" type="submit" :disabled="denomination===false" :class="{isDisabled: denomination===false}">
                            <span class="mc-button__text">
                                Перейти к оформлению
                            </span>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
  data: () => ({
    denomination: false
  }),
  mounted() {

  },
  created() {
    this.fetchCertificate();
  },
  computed: {
    ...mapGetters([
      'certificate',
      'certificateLoading',
      'certificateError',
      'certificateLoaded',
    ]),
  },
  components: {},
  methods: {
    ...mapActions([
      'fetchCertificate'
    ]),
  },
}
</script>

